import { useRegionContext } from 'common/contexts/RegionContext';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import * as Pages from '../../pages';

/**
 * This component renders a 404 or unavailable region message when a user attempts to access a
 * region that they are not targeted for.
 * @param props
 * @returns
 */
export const RegionGate: React.FC<{ children?: React.ReactNode | undefined }> = (props) => {
  const params = useParams();
  const { availableRegions } = useRegionContext();

  const regionRouteStatus = React.useMemo(() => {
    const { region } = params;
    // There isn't region info in the url, allow the user through
    if (!region) {
      return 'not-applicable';
    }

    // Check if the region in the URL is available to this user
    const actual = availableRegions.find((r) => r.route === region);
    if (!actual) {
      return 'filtered';
    }

    return 'valid';
  }, [params, availableRegions]);

  switch (regionRouteStatus) {
    case 'filtered':
      return <Pages.FilteredRegion />;
    default:
      // eslint-disable-next-line react/jsx-no-useless-fragment
      return <>{props.children}</>;
  }
};
